import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { Task } from 'ember-concurrency';
import PowerSelect from 'ember-power-select/components/power-select';
import { not, or } from 'ember-truth-helpers';
import ModalDialog from 'garaje/components/ui/classic/modal-dialog';
import UiButton from 'garaje/components/ui-button';
import preventDefault from 'garaje/helpers/prevent-default';
import type Group from 'garaje/models/group';

interface LocationsTableBulkModalAssignmentSignature {
  Args: {
    /**
     * List of available groups to be assigned
     */
    groups: Group[];
    assignGroupTask: Task<void, [group: Group]>;
    closeModal: () => void;
  };
  Element: HTMLDivElement;
}

/**
 * Modal to select a group to assign to multiple locations
 */
export default class LocationsTableBulkModalAssignment extends Component<LocationsTableBulkModalAssignmentSignature> {
  @tracked selectedGroup: Group | null = null;

  <template>
    <ModalDialog
      ...attributes
      @clickOutsideToClose={{false}}
      @containerClass="ember-modal-dialog--groups"
      @targetAttachment="center"
      @translucentOverlay={{true}}
    >
      <div data-test-groups-assignment-header class="bg-carbon-5 p-8 flex items-center">
        <div class="flex-auto min-w-0 min-h-0">
          <h2>Assign to group</h2>
        </div>
        <div class="flex-none">
          <button
            data-test-close-button
            type="button"
            aria-label="close"
            class="btn btn--small btn--outline btn--cancel"
            {{on "click" @closeModal}}
          >
            &times;
          </button>
        </div>
      </div>
      <div class="px-8 pt-6 bg-white pb-0">
        <form
          class="relative"
          {{on "submit" (preventDefault (fn @assignGroupTask.perform this.selectedGroup))}}
          style="min-height: 250px;"
        >
          <label class="block my-1 pt-2">Group</label>
          <div data-test-groups-assignment-dropdown class="w-full">
            <PowerSelect
              @options={{@groups}}
              @dropdownClass="in-modal"
              @onChange={{fn (mut this.selectedGroup)}}
              @selected={{this.selectedGroup}}
              as |group|
            >
              {{group.name}}
            </PowerSelect>
          </div>

          <UiButton
            data-test-save-group-button
            @type="submit"
            disabled={{if (or @assignGroupTask.isRunning (not this.selectedGroup)) true false}}
            class="btn btn--small btn--brand float-right absolute bottom-0 right-0 mb-6"
          >
            {{if @assignGroupTask.isRunning "Saving..." "Save"}}
          </UiButton>
        </form>
      </div>
    </ModalDialog>
  </template>
}
